import React, { useState } from 'react';

const TABS = [
  { id: 'player', label: 'Player Hub' },
  { id: 'games', label: 'Games' },
  { id: 'trends', label: 'Trends' },
  { id: 'picks', label: 'My Picks' }
];

function App() {
  const [activeTab, setActiveTab] = useState('player');

  return (
    <div className="app-root">
      <header className="top-nav">
        <div className="brand">
          <span className="brand-mark">PP</span>
          <div className="brand-text">
            <span className="brand-title">PropsParlor</span>
            <span className="brand-subtitle">NBA Props Intelligence</span>
          </div>
        </div>
        <div className="top-nav-right">
          <div className="env-pill">Cloudflare • Vite • React</div>
        </div>
      </header>

      <div className="tab-bar">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={
              'tab-pill' + (activeTab === tab.id ? ' tab-pill--active' : '')
            }
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <main className="app-shell">
        <section className="app-main">
          {activeTab === 'player' && <PlayerHubStub />}
          {activeTab === 'games' && <GamesStub />}
          {activeTab === 'trends' && <TrendsStub />}
          {activeTab === 'picks' && <PicksStub />}
        </section>

        <aside className="app-slip-panel">
          <SlipStub />
        </aside>
      </main>

      <footer className="app-footer">
        <span>PropsParlor • SpotstatsAi</span>
        <span className="footer-dot">•</span>
        <span>NBA props research workspace</span>
      </footer>
    </div>
  );
}

function Card({ title, children, compact = false }) {
  return (
    <div className={'pp-card' + (compact ? ' pp-card--compact' : '')}>
      {title && <div className="pp-card-header">{title}</div>}
      <div className="pp-card-body">{children}</div>
    </div>
  );
}

function PlayerHubStub() {
  return (
    <div className="grid-main">
      <Card title="Player Hub">
        <p className="stub-text">
          This is the PropsParlor shell. In the next steps, this area will host:
        </p>
        <ul className="stub-list">
          <li>BDL-powered player search</li>
          <li>Season averages and efficiency metrics</li>
          <li>Last 10 games with charts (PTS / REB / AST)</li>
          <li>Create Prop panel to send picks to the slip</li>
        </ul>
      </Card>

      <Card title="Layout Preview" compact>
        <p className="stub-text">
          Tabs above switch between core sections: Player Hub, Games, Trends,
          and My Picks. The right-hand panel is the always-on pick slip.
        </p>
      </Card>
    </div>
  );
}

function GamesStub() {
  return (
    <div className="grid-main">
      <Card title="Games – Today&apos;s Slate">
        <p className="stub-text">
          In a later step, this section will call a Cloudflare Function that
          proxies BallDontLie&apos;s <code>/games</code> endpoint to show
          today&apos;s matchups, status, and scores.
        </p>
      </Card>
    </div>
  );
}

function TrendsStub() {
  return (
    <div className="grid-main">
      <Card title="Trends – Hit Rates & Rolling Stats">
        <p className="stub-text">
          This area will host trends filters, hit-rate tables, and rolling
          charts powered by Chart.js once data endpoints are wired up.
        </p>
      </Card>
    </div>
  );
}

function PicksStub() {
  return (
    <div className="grid-main">
      <Card title="My Picks">
        <p className="stub-text">
          The full slip management experience will live here, synced with the
          always-on slip drawer on the right. For now, this is a placeholder.
        </p>
      </Card>
    </div>
  );
}

function SlipStub() {
  return (
    <div className="slip-shell">
      <div className="slip-header">
        <span className="slip-title">My Picks</span>
        <span className="slip-count-badge">0</span>
      </div>
      <p className="slip-empty-text">
        Pick slip shell ready.
        <br />
        Upcoming steps will allow you to:
      </p>
      <ul className="slip-empty-list">
        <li>Add picks from Player Hub</li>
        <li>Color-code lines vs season average</li>
        <li>Store up to 25 picks in localStorage</li>
      </ul>
    </div>
  );
}

export default App;
